export const loadState = () => {
  const state = localStorage.getItem('rstate');
  return state ? JSON.parse(state) : undefined;
};

export const saveState = (state) => {
  localStorage.setItem('rstate', JSON.stringify(state));
};
